import classNames from "classnames";
import RankDown from "rivals/components/shared/Icons/RankDown";
import RankHot from "rivals/components/shared/Icons/RankHot";
import RankUp from "rivals/components/shared/Icons/RankUp";
import {
  ICON_SIZE_10,
  ICON_SIZE_12
} from "rivals/components/shared/Icons/constants";
import strings from "rivals/components/shared/Tables/Cells/sharedStrings";
import { setData } from "rivals/shared/utils/qa";
import styles from "./RankChangeCell.module.scss";
import type { Props } from "./types";

const DATA_PHILTER = "rank-change-cell";
const HOT_MOVEMENT_THRESHOLD = 5;

// List rank change cell - applicable for all athlete rank tables
const RankChangeCell = ({ changeValue, className }: Props): JSX.Element => {
  if (changeValue === "new") {
    return (
      <div className={styles.rankingChangeWrapper}>
        <div className={styles.new}>{strings.new}</div>
      </div>
    );
  }

  if (!changeValue) {
    return (
      <div className={styles.rankingChangeWrapper}>{strings.emptyValue}</div>
    );
  }

  let hot = false;

  let icon =
    changeValue > 0 ? (
      <RankUp height={ICON_SIZE_12} width={ICON_SIZE_10} />
    ) : (
      <RankDown height={ICON_SIZE_12} width={ICON_SIZE_10} />
    );

  if (changeValue >= HOT_MOVEMENT_THRESHOLD) {
    icon = <RankHot />;
    hot = true;
  }

  return (
    <div
      className={classNames(className, styles.rankingChangeWrapper)}
      {...setData(DATA_PHILTER)}
    >
      <div>{Math.abs(changeValue)}</div>
      <div className={classNames(styles.iconContainer, hot && styles.hot)}>
        {icon}
      </div>
    </div>
  );
};

export default RankChangeCell;
